import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractAuthService } from 'src/app/services/auth/auth.abstract.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent {
  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated;
  }
  get isBpLoggedIn$(): Observable<boolean> {
    return this.authService.isBpLoggedIn$.asObservable();
  }
  constructor(private authService: AbstractAuthService) {}
}
